import Head from 'next/head'
import { sanityClient } from '@bww/beke-lib/sanity-client'
import BrandsHeader from '@bww/beke-ui/Brands/BrandsHeader'
import { HeaderTextBlock } from '@bww/beke-ui/PageHeader'
import BrandsSection from '@bww/beke-ui/Brands/BrandsSection'

export default function BrandsPage({ brands, pageContent }) {
  return (
    <>
      <Head>
        <title>Quality bathroom brands for all projects</title>
        <meta
          name="description"
          content="Bathroom products from a wide range of leading suppliers. From showers and baths to bathroom furniture."
        />
      </Head>
      <BrandsHeader
        title="Quality bathroom brands, reliably delivered"
        brands={brands}
      />
      <HeaderTextBlock style={{ paddingTop: 40 }}>
        <h2 className="h2" style={{ color: 'var(--color-primary)' }}>
          Everything you need under one roof
        </h2>
        <p>
          Bathroom Elegance offers products from a very wide range of leading
          bathroom suppliers.
          <br />
          Several of our brand partners provide complete bathroom solutions
          within their ranges but you also have total freedom to seamlessly mix
          and match from different brands.
        </p>
      </HeaderTextBlock>
      <BrandsSection content={pageContent} />
    </>
  )
}

export async function getStaticProps() {
  const { brands, pageContent } = await sanityClient.fetch(
    `{
      'brands': *[_type == "brand" && "be" in companies]{
        name,
        logo{ "src": asset->url, "bleedColor": bleedColor.hex }
      },
      'pageContent': *[_id == "be-brands"][0]{
        sections[]{
          title,
          description,
          brands[]->{
            name,
            description,
            url,
            "slug": slug.current,
            logo{ "src": asset->url, "bleedColor": bleedColor.hex }
          },
          images[]{ ..., "lqip": asset->metadata.lqip },
        }
      }
    }`,
  )

  return {
    props: {
      brands,
      pageContent,
    },
  }
}
